document.addEventListener("DOMContentLoaded", function () {
  const languageSelectorTrigger = document.querySelector('.js-languageselector--trigger');
  const languageSelectorList = document.querySelector('.js-languageselector--list');
  const languageSelectorOpenClass = 'is-open';

  if (languageSelectorTrigger && languageSelectorList) {
    languageSelectorTrigger.addEventListener('click', function () {
      if (languageSelectorList.classList.contains(languageSelectorOpenClass)) {
        languageSelectorList.classList.remove(languageSelectorOpenClass);
      } else {
        languageSelectorList.classList.add(languageSelectorOpenClass);
      }
    });
  }
});